<template>
  <div class="UploadDragScreen">
    <img
      :src="uploadImage"
      alt="Upload files"
      width="210"
      height="176"
      @dragleave.stop
    />
  </div>
</template>

<script lang="ts" setup>
import uploadImage from './assets/upload-files.svg'
</script>

<style scoped lang="scss">
.UploadDragScreen {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
